import { render, staticRenderFns } from "./PaymentTypeSelect.vue?vue&type=template&id=916e894a&scoped=true"
import script from "./PaymentTypeSelect.vue?vue&type=script&lang=js"
export * from "./PaymentTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916e894a",
  null
  
)

export default component.exports